<template>
  <div>
    <el-row class="bg-color-w py-20 px-30" v-if="xsym == '0'">
      <el-row type="flex" class="py-5" justify="space-between">
        <el-col :span="12">
          <div class="float-l">
            <div class="float-l">{{ $t("xmsq.bgnr") }}：</div>
            <div class="float-l">
              <el-button
                type="primary"
                size="mini"
                :icon="activeBtn == '1' ? 'el-icon-check' : 'el-icon-aim'"
                :plain="activeBtn == '2'"
                @click="setActiveBtn('1')"
              >
                {{ $t("xmsq.bsqrbg") }}
              </el-button>
              <el-button
                type="primary"
                size="mini"
                :icon="activeBtn == '2' ? 'el-icon-check' : 'el-icon-aim'"
                :plain="activeBtn == '1'"
                @click="setActiveBtn('2')"
              >
                {{ $t("xmsq.xmbg") }}
              </el-button>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row class="py-10">
        <!-- 批量导入/模板下载 -->
        <el-col :span="rqSpan" class="dy-flex" style="text-align: left;">
          <el-upload
            class="mr-20"
            action
            :on-change="handleChange"
            :show-file-list="false"
            :file-list="fileList"
            :limit="2"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            :auto-upload="false"
          >
            <el-button size="small" type="primary"
              >{{ $t("xmsq.pldr") }}<el-icon class="el-icon-plus"></el-icon
            ></el-button>
          </el-upload>
          <el-button size="small" type="primary" @click="filedownload"
            >{{ $t("xmsq.mbxz") }}<el-icon class="el-icon-download"></el-icon
          ></el-button>
        </el-col>

        <!-- 权限迁移 -->
        <el-col :span="anSpan" class="">
          <div class="float-r">
            <el-button size="small" type="primary" @click="sqbgMethod">{{
              $t("xmsq.sqbg")
            }}</el-button>
            <el-button
              type="primary"
              size="mini"
              class="ml-10"
              @click="goWdsq()"
            >
              {{ $t("xmsq.wdsq") }}
            </el-button>
          </div>
        </el-col>
        <!-- <p v-if="activeBtn == '1'" class="color-r mt-20">
          * 提示：点击"序号"左侧的小三角，可展开该授权记录的详细操作日志。
        </p> -->
      </el-row>
      <el-row class="mt-10">
        <p class="fs-14 color-dg" v-if="tableData.length > 0">
          共导入{{ tableData.length }}条数据
        </p>
        <!-- 动态表格组件 -->
        <TableCommon
          v-loading="tabLoading"
          :element-loading-text="$t('elTable.loadingText')"
          element-loading-spinner="el-icon-loading"
          :tableColumns="tableColumns"
          :tableData="tableData"
          :uniqueNum="uniqueNum"
          :cellStyle="$store.state.cellStyle"
          :headerCellStyle="$store.state.headerCellStyle"
          :height="$store.state.screenHeight - 295"
        ></TableCommon>
      </el-row>
    </el-row>
    <el-row class="bg-color-w py-20 px-30" v-if="xsym == '1'">
      <el-row class="">
        <!-- 返回数据变更页 -->
        <el-col :span="rqSpan" class="dy-flex" style="text-align: left;">
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('xmsq.fhsjbg')"
            placement="right"
          >
            <el-button size="medium" type="text" @click="back">
              <i class="fa fa-reply fa-2x" />
              <!-- {{ $t("xmsq.back") }} -->
            </el-button>
          </el-tooltip>
        </el-col>
      </el-row>
      <!-- 动态表格组件 -->
      <TableCommon
        v-loading="tabLoading2"
        :element-loading-text="$t('elTable.loadingText')"
        element-loading-spinner="el-icon-loading"
        :tableColumns="tableColumns2"
        :tableData="tableData3"
        :uniqueNum="uniqueNum2"
        :cellStyle="$store.state.cellStyle"
        :headerCellStyle="$store.state.headerCellStyle"
        :height="$store.state.screenHeight - 247"
        @handleClickFun="handleClickFun"
      ></TableCommon>
    </el-row>
    <DialogBox
      :dialogVisible="dialogVisible"
      :title="$t('sqsq.details')"
      class=""
      :showCancel="false"
      :showConfirm="false"
      @cancel="cancel"
    >
      <template slot="content">
        <el-row class="">
          <div ref="title" class="title px-20">
            <!-- <div class="" style="font-size: 25px;">
              申请信息
            </div> -->
            <p class="dy-flex mt-10">
              <span class="fw-bold fs-15">{{$t('xmsq.bgnr')}}：</span>
              <span class="fs-15">{{ fromData.bgnr }}</span>
            </p>
            <p class="dy-flex mt-5">
              <span class="fw-bold fs-15">{{$t('xmsq.shzt')}}：</span>
              <span class="fs-15">{{ fromData.shzt }}</span>
            </p>
            <p class="fw-bold fs-15 mt-10 mb-5">
              {{$t('sqsq.Applynews')}}
            </p>
          </div>
          <el-form ref="form" :model="fromData" :label-width="$i18n.locale=='zh'?'90px':'140px'">
            <el-card>
              <el-form-item :label="$t('sqsq.applicant')" class="mb-10 fw-bold fs-15">
                {{ fromData.czry + "/" + fromData.czrymc }}
              </el-form-item>
              <el-form-item :label="$t('sqsq.Applytime')" class="mb-10 fw-bold fs-15">
                {{ fromData.czsj }}
              </el-form-item>
              <el-form-item
                :label="$t('xmsq.jgh')"
                class="mb-10 fw-bold fs-15"
                v-if="fromData.bglx == '0'"
              >
                {{ fromData.jbh }}
              </el-form-item>
              <el-form-item
                :label="$t('xmsq.xgh')"
                class="mb-10 fw-bold fs-15"
                v-if="fromData.bglx == '0'"
              >
                {{ fromData.xbh }}
              </el-form-item>
              <el-form-item
                :label="$t('xmsq.jxmbh')"
                class="mb-10 fw-bold fs-15"
                v-if="fromData.bglx == '1'"
              >
                {{ fromData.jbh }}
              </el-form-item>
              <el-form-item
                :label="$t('xmsq.xxmbh')"
                class="mb-10 fw-bold fs-15"
                v-if="fromData.bglx == '1'"
              >
                {{ fromData.xbh }}
              </el-form-item>
            </el-card>
            <p
              class="fw-bold fs-15 mt-10 mb-5 pl-20"
              v-if="fromData.shzt != '待审核'"
            >
              <span>{{$t('sqsq.examinenews')}}</span>
            </p>
            <el-card v-if="fromData.shzt != '待审核'">
              <el-form-item :label="$t('sqsq.Reviewedby')" class="mb-10 fw-bold fs-15">
                {{ fromData.shry + "/" + fromData.shrymc }}
              </el-form-item>
              <el-form-item :label="$t('sqsq.Audittime')" class="mb-10 fw-bold fs-15">
                {{ fromData.shsj }}
              </el-form-item>
              <el-form-item
                :label="$t('sqsq.Reasonrejection')"
                class="mb-10 fw-bold fs-15"
                v-if="fromData.shzt == '驳回'"
              >
                {{ fromData.bhyy }}
              </el-form-item>
            </el-card>
          </el-form>
        </el-row>
      </template>
    </DialogBox>
  </div>
</template>

<script>
// import * as sqgl from "@/api/sqgl";
import * as sqgl from "@/api/qhsqgl";
import * as yhxx from "@/api/yhxx";
import { downLoadFile, openDialogDownload } from "@/api/common";
import DialogBox from "@/components/DialogBox.vue";

export default {
  // 项目变更
  name: "projectChange",
  components: { DialogBox },
  computed: {
    tableStyle() {
      return {
        width: this.$store.state.screenWidth - 387 + "px",
        margin: "auto",
      };
    },
    rqSpan() {
      let w = this.$store.state.screenWidth;
      if (w > 1920) {
        return 20;
      } else if (1920 >= w && w > 1680) {
        return 20;
      } else if (1680 >= w && w > 1440) {
        return 19;
      } else if (1440 >= w) {
        return 16;
      }
    },
    anSpan() {
      let w = this.$store.state.screenWidth;
      if (w > 1920) {
        return 4;
      } else if (1920 >= w && w > 1680) {
        return 4;
      } else if (1680 >= w && w > 1440) {
        return 5;
      } else if (1440 >= w) {
        return 8;
      }
    },
  },
  data() {
    return {
      dialogVisible: false,
      tableColumns: [],
      tableColumns2: [],
      tableData: [],
      tableData1: [],
      tableData2: [],
      tableData3: [],
      uniqueNum: "Y120117-1-1", // 页面唯一标识（用于区分同一页面多个模块多个分组情况）
      uniqueNum2: "Y120117-1-2",
      yhxx: this.$store.state.yhxx.yhxx,
      bsqr: "",
      flg: "0",
      saveflg: "0",
      rydm: null,
      activeBtn: "1",
      params: {},
      fileTemp: null,
      fileList: [],
      tabLoading: false,
      tabLoading2: false,
      xsym: "0",
      fromData: {},
    };
  },
  methods: {
    setActiveBtn(active) {
      this.tableData = [];
      this.activeBtn = active;
      if (active == "1") {
        this.tableData = this.tableData1;
        this.tableColumns[2].isShow = "0";
        this.tableColumns[3].isShow = "0";
        this.tableColumns[4].isShow = "1";
        this.tableColumns[5].isShow = "1";
      } else if (active == "2") {
        this.tableData = this.tableData2;
        this.tableColumns[2].isShow = "1";
        this.tableColumns[3].isShow = "1";
        this.tableColumns[4].isShow = "0";
        this.tableColumns[5].isShow = "0";
      }
    },

    /** 获取页面表格配置信息 */
    getPageTableConfig() {
      let params = {};
      params.pageId = "Y120117";
      params.moduleId = "1";
      params.groupId = "1";
      // 清空表格列配置
      this.tableColumns = []; // 表格列
      // 异步回调
      this.$requestUtil.getXtTableConfig(params).then((tmpResult) => {
        if (this.activeBtn == "1") {
          tmpResult[2].isShow = "0";
          tmpResult[3].isShow = "0";
          tmpResult[4].isShow = "1";
          tmpResult[5].isShow = "1";
        } else if (this.activeBtn == "2") {
          tmpResult[2].isShow = "1";
          tmpResult[3].isShow = "1";
          tmpResult[4].isShow = "0";
          tmpResult[5].isShow = "0";
        }
        this.tableColumns = tmpResult;
      });
    },

    /** 获取页面表格配置信息 */
    getPageTableConfig2() {
      let params = {};
      params.pageId = "Y120117";
      params.moduleId = "1";
      params.groupId = "2";
      // 清空表格列配置
      this.tableColumns2 = []; // 表格列
      // 异步回调
      this.$requestUtil.getXtTableConfig(params).then((tmpResult) => {
        this.tableColumns2 = tmpResult;
      });
    },

    //   获取数据变更申请数据
    getMySjbgsq() {
      this.tabLoading2 = true;
      sqgl.getMySjbgsq().then((res) => {
        let data = [];
        data = res.data.data;
        data.forEach((item) => {
          switch (item.status) {
            case "1":
              item.shzt = "通过";
              // this.zeroData.push(item);
              break;
            case "2":
              item.shzt = "驳回";
              // this.oneData.push(item);
              break;
            case "0":
              item.shzt = "待审核";
              // this.twoData.push(item);
              break;
          }
          item.status = undefined;
        });
        this.tableData3 = data;
        this.tabLoading2 = false;
      });
    },

    // 显示我的申请页面
    goWdsq() {
      this.xsym = "1";
    },

    back() {
      this.xsym = "0";
    },

    // 点击按钮或链接
    async handleClickFun(row) {
      // console.log("点击按钮或链接")
      this.form = {
        id: "",
        bglx: "",
        bhyy: "",
        status: 0,
      };
      this.fromData = {};
      let r = row.row;
      if (row.oprationflg.en == "audit") {
        this.dialogVisible = true;
      }
      this.fromData = this.$clone.cloneDeep(r);
      if(this.fromData.bglx == '1') {
        let xxmmc = await this.getProjectName(this.fromData.xbh)
        let jxmmc = await this.getProjectName(this.fromData.jbh)
        this.fromData.xbh = this.fromData.xbh+"/"+xxmmc;
        this.fromData.jbh = this.fromData.jbh+"/"+jxmmc;
      } else if(this.fromData.bglx == '0') {
        let xygmc = await this.getUserName(this.fromData.xbh)
        let jygmc = await this.getUserName(this.fromData.jbh)
        this.fromData.xbh = this.fromData.xbh+"/"+xygmc;
        this.fromData.jbh = this.fromData.jbh+"/"+jygmc;
      }
      this.form = this.$clone.cloneDeep(r);
    },

    // 取消审核
    cancel() {
      this.dialogVisible = false;
    },

    // 导入文件
    handleChange(file, fileList) {
      this.fileList = [];
      this.fileTemp = file.raw;
      if (this.fileTemp) {
        if (
          this.fileTemp.type ===
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
          this.fileTemp.type === "application/vnd.ms-excel"
        ) {
          this.importfxx(this.fileTemp);
        } else {
          this.$message({
            type: "warning",
            message: "附件格式错误，请删除后重新上传！",
          });
        }
      } else {
        this.$message({
          type: "warning",
          message: "请上传附件！",
        });
      }
    },

    //   解析excel文件
    importfxx(obj) {
      // 通过DOM取文件数据
      this.file = obj;
      const rABS1 = false; // 是否将文件读取为二进制字符串
      const f = this.file;
      const reader = new FileReader();
      // if (!FileReader.prototype.readAsBinaryString) {
      FileReader.prototype.readAsBinaryString = (filereader) => {
        let binary = "";
        const rABS = false; // 是否将文件读取为二进制字符串
        let wb; // 读取完成的数据
        let outdata;
        const reader2 = new FileReader();
        reader2.onload = (e) => {
          const bytes = new Uint8Array(reader2.result);
          const length = bytes.byteLength;
          for (let i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          const XLSX = require("xlsx");
          if (rABS) {
            wb = XLSX.read(btoa(binary), {
              // 手动转化
              type: "base64",
            });
          } else {
            wb = XLSX.read(binary, {
              type: "binary",
            });
          }
          outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]); // outdata就是你想要的东西
          const da = [...outdata];
          const arr = [];
          da.map(async (v, index) => {
            const object = {};
            object.xh = v["序号"];
            object.bgnr = v["变更内容"];
            if (this.activeBtn == "1") {
              object.jgh = v["旧工号"];
              object.xgh = v["新工号"];
              object.bglx = "0";
              if (
                object.jgh != null &&
                object.xgh != null &&
                object.jgh != object.xgh
              ) {
                arr.forEach((item) => {
                  if (item.jgh == object.jgh) {
                    let val =
                      this.$t('xmsq.drdtghsjcf');
                    this.opennotify("warning", val);
                  }
                });
                let xghmc = await this.getUserName(object.xgh);
                let jghmc = await this.getUserName(object.jgh);
                if (xghmc == "false") {
                  let val = this.$t('xmsq.gh') + " [" + object.xgh + "] " + this.$t('xmsq.bczcs');
                  this.opennotify("error", val);
                } else if (jghmc == "false") {
                  let val = this.$t('xmsq.gh') + " [" + object.jgh + "] " + this.$t('xmsq.bczcs');
                  this.opennotify("error", val);
                } else {
                  object.jghmc = object.jgh + "/" + jghmc;
                  object.xghmc = object.xgh + "/" + xghmc;
                  arr.push(object);
                }
              } else {
                let val =
                this.$t('xmsq.Section') + (index + 1) + this.$t('xmsq.tsjwtdr');
                this.opennotify("error", val);
              }
            }
            if (this.activeBtn == "2") {
              object.jxmbh = v["旧项目编号"];
              object.xxmbh = v["新项目编号"];
              object.bglx = "1";
              if (
                object.jxmbh != null &&
                object.xxmbh != null &&
                object.jxmbh != object.xxmbh
              ) {
                arr.forEach((item) => {
                  if (item.jxmbh == object.jxmbh) {
                    let val =
                      this.$t('xmsq.drdtxmsjcf');
                    this.opennotify("warning", val);
                  }
                });
                let xxmmc = await this.getProjectName(object.xxmbh);
                let jxmmc = await this.getProjectName(object.jxmbh);
                // console.log("xxmmc", xxmmc);
                if (xxmmc == "false") {
                  let val =
                  this.$t('sqsq.project') + " [" + object.xxmbh + "] " + this.$t('xmsq.bczcs');
                  this.opennotify("error", val);
                } else if (jxmmc == "false") {
                  let val =
                    this.$t('sqsq.project') + " [" + object.jxmbh + "] " + this.$t('xmsq.bczcs');
                  this.opennotify("error", val);
                } else {
                  object.jxmbhmc = object.jxmbh + "/" + jxmmc;
                  object.xxmbhmc = object.xxmbh + "/" + xxmmc;
                  arr.push(object);
                }
              } else {
                let val =
                  this.$t('xmsq.Section') + (index + 1) + this.$t('xmsq.tsjwtdr');
                this.opennotify("error", val);
              }
            }
          });
          if (this.activeBtn == "1") {
            this.tableData1 = arr;
            this.tableData = this.tableData1;
          } else if (this.activeBtn == "2") {
            this.tableData2 = arr;
            this.tableData = this.tableData2;
          }
          return arr;
        };
        reader2.readAsArrayBuffer(filereader);
      };

      if (rABS1) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
    },

    async getUserName(yhbh) {
      return await yhxx.getUserName({ yhbh: yhbh }).then((res) => {
        if (res.data.data) {
          // console.log("res.data.data", res.data.data);
          return res.data.data;
        } else {
          // console.log("res.data.data", false);
          return "false";
        }
      });
    },

    async getProjectName(xmbh) {
      return await yhxx.getProjectName({ xmbh: xmbh }).then((res) => {
        if (res.data.data) {
          // console.log("res.data.data", res.data.data);
          return res.data.data;
        } else {
          // console.log("res.data.data", false);
          return "false";
        }
      });
    },

    opennotify(type, val) {
      setTimeout(() => {
        this.$message({
          message: val,
          type: type,
        });
      }, 10);
    },

    // 下载模板
    filedownload() {
      downLoadFile(
        "/api/rcsw/filedownload",
        this.$qs.stringify({
          fj: this.activeBtn == "1" ? "bsqrbgmb.xlsx" : "xmbgmb.xlsx",
        })
      ).then((res) => {
        if (res.status === 200) {
          this.dialogFormVisible2 = false;
          this.$message.success(this.$t('xmsq.xzfjcg'));
          // 进行下载，下载文件时，显示文件名称
          openDialogDownload(
            res,
            this.activeBtn == "1"
              ? "被授权人变更模板.xlsx"
              : "项目变更模板.xlsx"
          );
        }
      });
    },

    // 权限迁移
    sqbgMethod() {
      let lt = this.tableData.length;
      if(lt <= 0) {
        this.$message.error(this.$t('xmsq.qxdrsj'));
      } else if (this.activeBtn == "1") {
        this.bsqrbgMethed(lt);
      } else if (this.activeBtn == "2") {
        this.xmbgMethed(lt);
      }
    },

    // 被授权人变更方法
    bsqrbgMethed(lt) {
      this.$confirm(
        this.$t("xmsq.qrbsqrbg") + "*" + lt,
        this.$t("xmsq.Confirmationinformation"),
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$t("xmsq.confirmBtn"),
          cancelButtonText: this.$t("xmsq.cancelBtn"),
        }
      )
        .then((res) => {
          this.tabLoading = true;
          sqgl
            .changeProjectAudit(this.tableData)
            .then((res1) => {
              this.tabLoading = false;
              if (res1.data.code == "200") {
                this.$message.success(res1.data.message);
              }
            })
            .catch((error) => {
              this.tabLoading = false;
            });
        })
        .catch((action) => {});
    },

    // 项目变更方法
    xmbgMethed(lt) {
      this.$confirm(
        this.$t("xmsq.qrxmbg") + "*" + lt,
        this.$t("xmsq.Confirmationinformation"),
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$t("xmsq.confirmBtn"),
          cancelButtonText: this.$t("xmsq.cancelBtn"),
        }
      )
        .then((res) => {
          this.tabLoading = true;
          sqgl
            .changeProjectAudit(this.tableData)
            .then((res1) => {
              this.tabLoading = false;
              if (res1.data.code == "200") {
                this.$message.success(res1.data.message);
              }
            })
            .catch((error) => {
              this.tabLoading = false;
            });
        })
        .catch((action) => {});
    },
  },
  mounted() {
    this.params.yhbh = this.yhxx.ygbh;
    this.params.bsqr = this.rydm;
    this.getPageTableConfig();
    this.getPageTableConfig2();
    this.getMySjbgsq();
  },
};
</script>

<style lang="scss"></style>
